import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import MealPlanPage from './MealPlanPage';
import MealSlotEditPage from './MealSlotEditPage';
import SuggestWeekPage from './SuggestWeekPage';
import SuggestionRulesPage from './SuggestionRulesPage';
import MealPatternsPage from './MealPatternsPage';

/** Pages under /casa/refeicoes. */
const MealsRoutes: React.FC = () => (
  <Routes>
    <Route index element={<MealPlanPage />} />
    <Route path="refeicao/:slotId" element={<MealSlotEditPage />} />
    <Route path="sugerir" element={<SuggestWeekPage />} />
    <Route path="padroes" element={<MealPatternsPage />} />
    <Route path="regras" element={<SuggestionRulesPage />} />
    <Route path="*" element={<Navigate to="/casa/refeicoes" replace />} />
  </Routes>
);

export default MealsRoutes;
